import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface TermsSection {
    id: string;
    title: string;
    content: string[];
}

export interface TermsAndConditions {
    title: string;
    lastUpdated: string;
    sections: TermsSection[];
}

@Injectable({
    providedIn: 'root'
})
export class TermsService {

    constructor(private http: HttpClient) { }

    getTermsAndConditions(): Observable<TermsAndConditions> {
        return this.http.get<TermsAndConditions>('assets/data/terms-and-conditions.json');
    }
} 